import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { thunk } from 'redux-thunk';
import { createBrowserHistory } from 'history';
import createRootReducer from 'reducers';
import apiMiddleware from 'middleware/api';
import SocketDispatcher from './SocketDispatcher';
import socketMiddleware from 'middleware/SocketManager';

import { loadState, persistState } from './persistence';

function createConfiguredStore() {
  const socketDispatcher = new SocketDispatcher();
  const socket = socketDispatcher.connect();
  const history = createBrowserHistory();

  const initialState = loadState();

  const enhancers = [];
  const middleware = [
    thunk,
    routerMiddleware(history),
    apiMiddleware,
    socketMiddleware(socket)
  ];

  if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension());
    }
  }

  const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
  );

  const store = createStore(
    createRootReducer(history),
    initialState,
    composedEnhancers
  );

  socketDispatcher.bindToStore(store);

  store.subscribe(() => {
    const { isLoggedOut } = store.getState();

    if (isLoggedOut && window.location.pathname.indexOf('login') === -1) {
      window.location.assign(`/login?redirect=${window.location.href}`);
    }
  });

  //Persist the team
  store.subscribe(() => {
    const { team } = store.getState();

    persistState({
      team
    });
  });

  return {
    store,
    history
  };
}

export { createConfiguredStore };
